import {TNavigation} from "../types/navigation/navigationTypes";

export const MainTitlesText: {[key in TNavigation]: string} = {
    login: 'Login',
    export: 'Export audiences',
    faq: 'FAQ',
    support: 'Support',
    '404': '404',
    filter: 'General Audiences',
    custom: 'My Custom Audiences',
    pixel: 'PIXEL Connection',
    files: 'Upload files CSV, XLSX',
}